export default "__VITE_ASSET__D8s8Q0Ym__"